import { putBrand, globalPut } from '../index';

export const updateBrand = ({ id, body }) => {
  console.log({body})
  return putBrand(id, body, false);
}

export const editBrandPut = data => {
  return globalPut(`/brands` , data, false);
}
